export const PROMOTION_STATUS = {
  DRAFT: 'DRAFT',
  GOING: 'GOING',
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
};

export const MARKETING_PROMOTION_STATUS_LABEL = {
  [PROMOTION_STATUS.DRAFT]: 'Chưa cập nhật',
  [PROMOTION_STATUS.PENDING]: 'Đã cập nhật',
  [PROMOTION_STATUS.GOING]: 'Đang diễn ra',
  [PROMOTION_STATUS.COMPLETED]: 'Đã kết thúc',
};

export const MARKETING_PROMOTION_STATUS_FILTER_OPTIONS = [
  { value: '', label: 'Tất cả trạng thái' },
  ...Object.values(PROMOTION_STATUS).map((status) => ({
    value: status,
    label: MARKETING_PROMOTION_STATUS_LABEL[status],
  })),
];

export const PROMOTION_TAB_LIST = [
  {
    name: 'Đang hoạt động',
    value: PROMOTION_STATUS.GOING,
  },
  {
    name: 'Sắp diễn ra',
    value: PROMOTION_STATUS.PENDING,
  },
  {
    name: 'Đã kết thúc',
    value: PROMOTION_STATUS.COMPLETED,
  },
];

export const PROMOTION_TYPE = {
  BASIC: 'BASIC',
  LONG_TERM: 'LONG_TERM',
  LAST_DAY: 'LAST_DAY',
  BOOK_EARLY: 'BOOK_EARLY',
  SAME_PROMOTION: 'SAME_PROMOTION',
  MEMBER_PROMOTION: 'MEMBER_PROMOTION',
  TOURIST: 'TOURIST',
  ENTERPRISE: 'ENTERPRISE',
  AGENCY: 'AGENCY',
  RANK: 'RANK',
  MARKETING: 'MARKETING',
};

export const PROMOTION_CATEGORY = {
  ACCOUNT: 'ACCOUNT',
  LIMITED: 'LIMITED',
};
